import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

import { TreeFilterService } from './tree-filter.service';
import { PaletteService } from './palette.service';
import { TimeUtilsService } from './time-utils.service';
import { StaticDataService } from './static-data.service';
import { MetadataService } from './metadata.service';
import { OpendapService } from './opendap.service';
import { TimeseriesService } from './timeseries.service';
import { PointSelectionService } from './point-selection.service';
import { AvailableDatesService } from './available-dates.service';
import { CatalogService } from './catalog.service';
import { MapViewParameterService } from './map-view.service';
import { WMSService } from './wms.service';
import { ProjectionService } from './projection.service';
import { AnalyticsService } from './analytics.service';
import { HighlightDirective } from './highlight.directive';
import { CoverageTableComponent } from './coverage-table/coverage-table.component';
import { CookieInformationComponent } from './cookie-information/cookie-information.component';
import { ExtentManagerComponent } from './extent-manager/extent-manager.component';
import { BoundsControlComponent } from './bounds-control.component';
import { ExtentsService } from './extents.service';
import { PopoverLockService } from './popover-lock.service';

export * from './data';

export * from './wms.service';
export * from './projection.service';
export * from './map-view.service';
export * from './interpolation.service';
export * from './available-dates.service';
export * from './point-selection.service';
export * from './metadata.service';
export * from './catalog.service';
export * from './palette.service';
export * from './static-data.service';
export * from './opendap.service';
export * from './timeseries.service';
export * from './time-utils.service';
export * from './tree-filter.service';
export * from './extents.service';
export * from './analytics.service';
export * from './parsing/csv';
export * from './highlight.directive';
export * from './coverage-table/coverage-table.component';
export * from './cookie-information/cookie-information.component';
export * from './extent-manager/extent-manager.component';
export * from './bounds-control.component';
export * from './popover-lock.service';
export * from './legend-utils';
export * from './util';

export { palettes as colorbrewer } from './colorbrewer';


const services = [
  //$serviceList
  AvailableDatesService,
  PointSelectionService,
  TimeseriesService,
  StaticDataService,
  MetadataService,
  OpendapService,
  PaletteService,
  TimeUtilsService,
  WMSService,
  MapViewParameterService,
  ProjectionService,
  CatalogService,
  TreeFilterService,
  AnalyticsService,
  ExtentsService,
  PopoverLockService
];

const declarations = [
  HighlightDirective,
  CoverageTableComponent,
  CookieInformationComponent,
  BoundsControlComponent,
  ExtentManagerComponent
];
//import { CSVService } from './src/csv.service';

//$importList

//$exportList


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    HttpClientModule
  ],
  declarations: declarations,
  exports: declarations,
  providers: services
})
export class MapWaldCoreModule {
  static forRoot(moduleInitialisation: any): ModuleWithProviders<MapWaldCoreModule> {
    return {
      ngModule: MapWaldCoreModule,
      providers: services
    };
  }
}

